import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders,HttpResponse } from '@angular/common/http';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/zipAll';

@Injectable()
export class ExamPlayerService {

    public Type = 135;
    public content: any;
    constructor(private http: HttpClient,private http1: Http) {

    }	
    GetTestQuestions(AssessmentID): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
        this.content = { AssessmentID: AssessmentID };
        return this.http.post('PlayTest.aspx/TestQuestions'
            , this.content).map((response: any) => {
                return response;
            });

    }

    GetTryoutQuestions(AssessmentID): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
        this.content = { AssessmentID: AssessmentID };
        return this.http.post('TestTryOut.aspx/TestQuestions'
            , this.content).map((response: any) => {
                return response;
            });

    }



    EvaluateQuestionUserResponse(moData, SectionInfo): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
        this.content = { userResponseObject: moData, Section: SectionInfo };
        return this.http.post('PlayTest.aspx/EvaluateEachItem'
            , this.content).map((response: any) => {
                return response;
            });

    }
    GetAdaptiveSectionQuestion(suid: any, sectionobj: any) {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
        this.content = { scheduleUserID: suid, testSection: sectionobj, IsFirstTime: false };
        return this.http.post('PlayTest.aspx/GetUserSessionSectionDetails'
            , this.content).map((response: any) => {
                return response;
            });
    }
    GetTestInctructions(userData): Observable<any[]> {
        return this.http.post('./api/Instructions/CheckInstruction', userData).map((response: any) => {
            return response;
        });
    }
    GetFile(templateUrl: any) {
        return this.http1.get(templateUrl).
            map((html: any) => { return html });
    }
    StoreBookMarkedStatus(path, moData: any): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
        this.content = { userResponseObject: moData };
        return this.http.post(location.protocol + "//" + window.location.host + '/' + path + '/Test/Play.aspx/StoreBookmarkedQuestion'
            , this.content).map((response: any) => {
                return response;
            });
    }
    //ReturnParam(path,moData:any){
    //    var headers1 = new Headers();
    //    headers1.append('Content-Type', 'application/json');
    //    this.content = { userResponseObject: moData };        
    //      return this.http.post(location.protocol + "//" + window.location.host + '/'+path + '/Test/Play.aspx/ReturnParam'
    //        , this.content).map((response: Response) => {
    //            return response.json();
    //        });
    //}
    GetSolutionQuestions(AssessmentID): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
        this.content = { AssessmentID: AssessmentID };
        return this.http.post('PlayTest.aspx/SolutionQuestions'
            , this.content).map((response: any) => {
                return response;
            });

    }
    ForceSubmitExam(moData): Observable<any> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
        this.content = { userResponseObject: moData };
        return this.http.post('PlayTest.aspx/ForceSubmitExam', this.content).map((response: any) => {
            return response;
        });
    }
    GetTestResultSummary(moData): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');		
        this.content = { strQuestionTypes:" " ,isAllQuestions: moData};		
        return this.http.post('PlayTest.aspx/GetTestResultSummary', this.content).map((response: any) => {
            return response;
        });		
    }
    ReturnParam(moData): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json'); 
        this.content = { userResponseObject: moData };
        return this.http.post('PlayTest.aspx/ReturnParam'
            , this.content).map((response: any) => {
                return response;
            });
    }
    GetReviewQuestions(path, ScheduleUserId): Observable<[any[]]> {
        var header1 = new HttpHeaders();
        header1.append('content-Type', 'application/json');
        this.content = { suid: ScheduleUserId };
        return this.http.post(location.protocol + "//" + window.location.host + '/' + path + '/PlayTest.aspx/SectionReviewDetails'
            , this.content).map((response: any) => {
                return response;
            });
    }
    SetReviewTestPref(val): Observable<[any[]]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json'); 
        this.content = { IsReview: val };
        return this.http.post('PlayTest.aspx/ReviewTestPref'
            , this.content).map((response: any) => {
                return response;
            });
    }
    ReturnTOReport(moData): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
        this.content = { val: moData };
        return this.http.post('PlayTest.aspx/RedirectToReport'
            , this.content).map((response: any) => {
                return response;
            });
    }
    StoreTestdata(moData): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
        this.content = { userResponseObject: moData };
        return this.http.post('PlayTest.aspx/StoreTestData'
            , this.content).map((response: any) => {
                return response;
            });
    }
    UpdateBookmarkQuesOnReview(schUserId, QuesGuid, Ismarked): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
        this.content = { ScheduleUserID: schUserId, QuesGUID: QuesGuid, IsMarked: Ismarked };
        return this.http.post('PlayTest.aspx/UpdateBookmarkedOnReview'
            , this.content).map((response: any) => {
                return response;
            });
    }
	UpdateTestStatus(): Observable<any[]> {
        var headers1 = new Headers();
        headers1.append('Content-Type', 'application/json');
        this.content = { };
        return this.http.post('PlayTest.aspx/UpdateTestStatus'
            , this.content).map((response: any) => {
                return response;
            });

    }
	 UpdateCurrentDetails(sectionID, QuesGuid): Observable<any[]> {
        var headers1 = new Headers();
        headers1.append('Content-Type', 'application/json');
        this.content = { blockID: sectionID, QID: QuesGuid, SyncID: 0 };
        return this.http.post('PlayTest.aspx/UpdateTestCurrentDetails'
            , this.content).map((response: any) => {
                return response;
            });
    }
	RedirectToNMATReport(requestPath,assessmentID,productID): Observable<any[]> {
        var headers1 = new HttpHeaders();
        headers1.append('Content-Type', 'application/json');
		if(productID==null) productID=0;
        this.content = { AssessmentID: assessmentID, ProductID: productID};
        return this.http.post(location.protocol + "//" + window.location.host + '/' + requestPath +'/Category/List.aspx/RedirectToReport'
            , this.content).map((response: any) => {
                return response;
            });
    }
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/_services/ExamPlayerService.ts